/* tslint:disable */
/* eslint-disable */
/**
 * Microsoft Graph Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    mobilePhone?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    mail?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    jobTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    preferredLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    userPrincipalName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    department?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    givenName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfo
     */
    surname?: string;
}

/**
 * Check if a given object implements the UserInfo interface.
 */
export function instanceOfUserInfo(value: object): value is UserInfo {
    return true;
}

export function UserInfoFromJSON(json: any): UserInfo {
    return UserInfoFromJSONTyped(json, false);
}

export function UserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'mobilePhone': json['mobilePhone'] == null ? undefined : json['mobilePhone'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'jobTitle': json['jobTitle'] == null ? undefined : json['jobTitle'],
        'preferredLanguage': json['preferredLanguage'] == null ? undefined : json['preferredLanguage'],
        'userPrincipalName': json['userPrincipalName'] == null ? undefined : json['userPrincipalName'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'department': json['department'] == null ? undefined : json['department'],
        'givenName': json['givenName'] == null ? undefined : json['givenName'],
        'surname': json['surname'] == null ? undefined : json['surname'],
    };
}

export function UserInfoToJSON(json: any): UserInfo {
    return UserInfoToJSONTyped(json, false);
}

export function UserInfoToJSONTyped(value?: UserInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mobilePhone': value['mobilePhone'],
        'displayName': value['displayName'],
        'mail': value['mail'],
        'jobTitle': value['jobTitle'],
        'preferredLanguage': value['preferredLanguage'],
        'userPrincipalName': value['userPrincipalName'],
        'companyName': value['companyName'],
        'department': value['department'],
        'givenName': value['givenName'],
        'surname': value['surname'],
    };
}

